import { differenceInMonths, endOfDay, format, isAfter, isBefore, isValid, parse, parseISO, set } from 'date-fns';

export {
  addDays,
  addHours,
  addMonths,
  addYears,
  differenceInDays,
  differenceInHours,
  differenceInMilliseconds,
  differenceInMinutes,
  differenceInSeconds,
  differenceInYears,
  endOfDay,
  endOfMonth,
  endOfWeek,
  intervalToDuration,
  isAfter,
  isBefore,
  startOfDay,
  startOfMonth,
  startOfWeek,
  subDays,
  subHours,
  subMinutes,
  subMonths,
  subSeconds,
  subYears
} from 'date-fns';

const INVALID_DATE = 'Invalid date';

export const toDate = (input: unknown): Date | null => {
  if (input === undefined) {
    return new Date();
  }
  if (input instanceof Date) {
    return isValid(input) ? input : null;
  }
  if (typeof input === 'number') {
    const fromNumber = new Date(input);
    return isValid(fromNumber) ? fromNumber : null;
  }
  if (typeof input === 'string') {
    const iso = parseISO(input);
    if (isValid(iso)) {
      return iso;
    }
    const fallback = new Date(input);
    return isValid(fallback) ? fallback : null;
  }
  return null;
};

export const formatDate = (input: unknown, dateFormat: string): string => {
  const date = toDate(input);
  if (!date) {
    return INVALID_DATE;
  }

  return format(date, dateFormat);
};

export const formatIso = (input: unknown): string => {
  const date = toDate(input);
  if (!date) {
    return INVALID_DATE;
  }

  return format(date, "yyyy-MM-dd'T'HH:mm:ssxxx");
};

export const isAfterNow = (input: unknown): boolean => {
  const date = toDate(input);

  return !!date && isAfter(date, new Date());
};

export const isBeforeNow = (input: unknown): boolean => {
  const date = toDate(input);

  return !!date && isBefore(date, new Date());
};

export const utcWallClock = (date: Date): Date => new Date(date.getTime() + date.getTimezoneOffset() * 60000);

export const monthsBetween = (start: unknown, end: unknown): number => {
  const startDate = toDate(start);
  const endDate = toDate(end);
  if (!startDate || !endDate) {
    return 0;
  }

  return differenceInMonths(endDate, startDate);
};

export function getDueAtTime(due_date: string, due_time?: string | null): string {
  let dueAt = parseISO(due_date);

  if (due_time) {
    const isHHmm = /^\d{2}:\d{2}$/.test(due_time);
    const parsed = isHHmm ? parse(due_time, 'HH:mm', new Date()) : new Date(due_time);
    dueAt = set(dueAt, { hours: parsed.getHours(), minutes: parsed.getMinutes(), seconds: 0, milliseconds: 0 });
  } else {
    dueAt = endOfDay(dueAt);
  }

  return dueAt.toISOString();
}
